import React from 'react'
import snapchat from '../../assets/svg/snapchat-color.svg'
import bereal from '../../assets/svg/bereal-color.svg' 
import tvtime from '../../assets/svg/tvtime-color.svg' 
import instagram from '../../assets/svg/instagram-color.svg' 
import { TitleCard } from '../common'


const SOCIALS = [
  { name: 'Instagram', icon: instagram, url: "https://www.instagram.com/notalepower?igsh=cHc3dnc2bDlhNjRx" },
  { name: 'Snapchat', icon: snapchat, url: "https://www.snapchat.com/add/alepower?share_id=QO633sb7P5M" },
  { name: 'Bereal', icon: bereal, url: "https://bere.al/alepower" },
  { name: 'TvTime', icon: tvtime, url: "https://tvtime.com/r/34SY4" }
]

const SocialItem = ({ name, icon, url }) =>{
  return(
      <a target="_blank" rel="noreferrer" className='container max-w-20 flex justify-center justify-items-center aspect-square p-2 rounded-2xl sm:rounded-3xl sm:p-4 bg-stone-200 dark:bg-stone-400' href={url}> <img className='max-w-12' src={icon} alt={name}/></a>
  )
}

export const Social = () => {
  return (
      <div className='mt-4 px-6 xl:px-20 2xl:px-40 py-4 bg-stone-100 dark:bg-stone-600'>
          <div className='flex justify-between sm:justify-start items-center gap-6 sm:gap-10'> 
            <TitleCard>SOCIALS</TitleCard>
            {SOCIALS.map((social) => (<SocialItem key={social.name} {...social} />))}
          </div>
      </div>
  )
}
